import { Injectable } from '@angular/core';

import { DtoToTemplateHelperService, TemplateToDtoHelperService } from './helper';
import { ReportTemplate, ReportTemplateDto } from './model';

@Injectable()
export class ReportTemplateAdapterService {
    constructor(
        private readonly dtoToTemplateHelper: DtoToTemplateHelperService,
        private readonly templateToDtoHelper: TemplateToDtoHelperService,
    ) {}

    /**
     * Adapt report template in ui to report template according dto
     * @param template : report template rendered in ui
     */
    adaptFromTemplateToDto(template: ReportTemplate): ReportTemplateDto {
        return {
            id: template.id,
            sections: this.templateToDtoHelper.formatSectionsDto(template.sections),
        };
    }

    /**
     * Adapt report template dto to report temmplate which will be rendered in ui
     * @param templateDto : report template according dto
     */
    adaptFromDtoToTemplate(templateDto: ReportTemplateDto): ReportTemplate {
        const creationDate = templateDto.creationDate ? new Date(templateDto.creationDate) : null;

        return {
            sections: this.dtoToTemplateHelper.formatUISections(templateDto),
            id: templateDto.id,
            creationDate,
        };
    }
}
